'use client';
import React from 'react';
import MultiSelect from '@/components/ui/multi-select';
import { LazySection } from '@/components/ui/LazySection';

interface PlatformFilterBarProps {
  providerOptions: string[];
  technologyOptions: string[];
  samplesOptions: string[];
  readoutOptions: string[];
  plexTypeOptions: string[];
  chemistryOptions: string[];
  resolutionOptions: string[];
  throughputOptions: string[];
  slideResolutionOptions: string[];
  applicationOptions: string[];
  selectedProviders: string[];
  setSelectedProviders: (v: string[]) => void;
  selectedTechnologies: string[];
  setSelectedTechnologies: (v: string[]) => void;
  selectedSamples: string[];
  setSelectedSamples: (v: string[]) => void;
  selectedReadouts: string[];
  setSelectedReadouts: (v: string[]) => void;
  selectedPlexTypes: string[];
  setSelectedPlexTypes: (v: string[]) => void;
  selectedChemistry: string[];
  setSelectedChemistry: (v: string[]) => void;
  selectedResolution: string[];
  setSelectedResolution: (v: string[]) => void;
  selectedThroughput: string[];
  setSelectedThroughput: (v: string[]) => void;
  selectedSlideResolution: string[];
  setSelectedSlideResolution: (v: string[]) => void;
  selectedApplication: string[];
  setSelectedApplication: (v: string[]) => void;
  techLoading?: boolean;
  productLoading?: boolean;
  providerLoading?: boolean;
}

export default function PlatformFilterBar(props: PlatformFilterBarProps) {
  return (
    <LazySection minHeight={60}>
      <div className="w-full mb-6">

        
        {/* Filter Grid - Two Rows of 5 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-2">
          {/* Row 1 */}
          <MultiSelect
            options={props.samplesOptions.map((sample) => ({ label: sample, value: sample }))}
            selected={props.selectedSamples}
            onChange={props.setSelectedSamples}
            placeholder="Sample Types"
            disabled={false}
          />
          <MultiSelect
            options={props.readoutOptions.map((readout) => ({ label: readout, value: readout }))}
            selected={props.selectedReadouts}
            onChange={props.setSelectedReadouts}
            placeholder="Readouts"
            disabled={false}
          />
          <MultiSelect
            options={props.plexTypeOptions.map((plex) => ({ label: plex, value: plex }))}
            selected={props.selectedPlexTypes}
            onChange={props.setSelectedPlexTypes}
            placeholder="Plex Types"
            disabled={false}
          />
          <MultiSelect
            options={props.resolutionOptions.map((res) => ({ label: res, value: res }))}
            selected={props.selectedResolution}
            onChange={props.setSelectedResolution}
            placeholder="Cellular Resolution"
            disabled={false}
          />
          <MultiSelect
            options={props.slideResolutionOptions.map((sr) => ({ label: sr, value: sr }))}
            selected={props.selectedSlideResolution}
            onChange={props.setSelectedSlideResolution}
            placeholder="Slide Resolution"
            disabled={false}
          />
          
          {/* Row 2 */}
          <MultiSelect
            options={props.throughputOptions.map((thru) => ({ label: thru, value: thru }))}
            selected={props.selectedThroughput}
            onChange={props.setSelectedThroughput}
            placeholder="Throughput"
            disabled={false}
          />
          <MultiSelect
            options={props.applicationOptions.map((app) => ({ label: app, value: app }))}
            selected={props.selectedApplication}
            onChange={props.setSelectedApplication}
            placeholder="Application"
            disabled={false}
          />
          <MultiSelect
            options={props.chemistryOptions.map((chem) => ({ label: chem, value: chem }))}
            selected={props.selectedChemistry}
            onChange={props.setSelectedChemistry}
            placeholder="Chemistry"
            disabled={false}
          />
          <MultiSelect
            options={props.technologyOptions.map((tech) => ({ label: tech, value: tech }))}
            selected={props.selectedTechnologies}
            onChange={props.setSelectedTechnologies}
            placeholder="Technology"
            disabled={props.techLoading}
          />
          <MultiSelect
            options={props.providerOptions.map((provider) => ({ label: provider, value: provider }))}
            selected={props.selectedProviders}
            onChange={props.setSelectedProviders}
            placeholder="Providers"
            disabled={props.providerLoading}
          />
        </div>
      </div>
    </LazySection>
  );
} 